/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 15:00:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

export const COMPLETE_RECHARGES_LIST = 'COMPLETE_RECHARGES_LIST';
export const SET_RECHARGES_TERMS = 'SET_RECHARGES_TERMS';



// WEBPACK FOOTER //
// ./src/store/modules/Recharges/mutation-types.js